import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'error-page',
    templateUrl: 'error.component.html',
    standalone: false
})

export class ErrorComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
